<ng-container *ngIf="!(error$ | async); else errorBlock">
  <ng-container *ngIf="screenWidth$ | async as screenWidth">
    <mat-sidenav-container
      *ngIf="!(routeIsLoading$ | async) && (loaded$ | async); else elseBlock"
      [ngClass]="{ 'login-background': !isLoggedIn && !whiteBackground }"
      class="mat-typography sidenav-container"
      fxFlexFill
    >
      <mat-sidenav
        #sidenav
        [mode]="screenWidth > 1260 ? 'side' : 'over'"
        [ngStyle]="{
          'background-color': isGroomRoom
            ? 'rgb(var(--palette-primary-500))'
            : null
        }"
        [opened]="
          !hideNavigation &&
          isLoggedIn &&
          (termsAgreed$ | async) &&
          screenWidth > 1260
        "
        role="navigation"
      >
        <div
          class="toolbar"
          [ngStyle]="{
            'background-color': isGroomRoom
              ? 'rgb(var(--palette-accent-500))'
              : null
          }"
          fxLayout="row"
          fxLayoutAlign="start center"
          [ngClass]="{ 'background-color': !whiteBackground }"
        >
          <p
            class="content-text"
            [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
            style="padding-left: 20px; margin: 0"
          >
            {{ clientPatientDetails?.themeSettings?.customName || defaultName }}
          </p>
        </div>
        <mat-nav-list>
          <!--Here to avoid default list selection of first item-->
          <a mat-list-item routerLink="/" style="height: 0"></a>
          <div *ngFor="let item of userRoutes">
            <a
              (click)="sidenav.mode === 'over' ? sidenav.close() : null"
              [routerLink]="[item.route]"
              mat-list-item
              routerLinkActive="list-item-active"
            >
              <mat-icon
                [color]="isGroomRoom ? 'accent' : 'primary'"
                matListIcon
                style="margin-right: 20px"
              >
                {{ item.icon }}
              </mat-icon>
              <h4
                style="margin: 0"
                [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
              >
                {{ item.title }}
              </h4>
            </a>
            <ng-container *ngIf="item.route === 'pets'">
              <ng-container
                *ngIf="item.children as children; else loadingBlock"
              >
                <a
                  (click)="
                    sidenav.mode === 'over' ? sidenav.close() : null;
                    itemClicked(child)
                  "
                  *ngFor="let child of children"
                  [routerLink]="[child.route]"
                  mat-list-item
                  routerLinkActive="list-item-active"
                >
                  <mat-icon
                    [color]="isGroomRoom ? 'accent' : 'primary'"
                    matListIcon
                    style="margin-right: 20px"
                  >
                    {{ child.icon }}
                  </mat-icon>
                  <p
                    class="no-margin"
                    [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
                  >
                    {{ child.title }}
                  </p>
                </a></ng-container
              >
              <ng-template #loadingBlock>
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="20px"
                  style="margin-left: 20px"
                >
                  <mat-progress-spinner
                    color="primary"
                    diameter="30"
                    mode="indeterminate"
                  ></mat-progress-spinner>
                  <p>Retrieving pet details</p>
                </div>
              </ng-template>
              <a
                (click)="sidenav.mode === 'over' ? sidenav.close() : null"
                *ngIf="
                  item.title.toLowerCase().indexOf('pet') !== -1 && canAddPet
                "
                [routerLink]="'/pets/new'"
                mat-list-item
                routerLinkActive="list-item-active"
              >
                <mat-icon
                  [color]="isGroomRoom ? 'accent' : 'primary'"
                  matListIcon
                  style="margin-right: 20px"
                >
                  add
                </mat-icon>
                <p
                  class="no-margin"
                  [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
                >
                  Add pet
                </p>
              </a></ng-container
            >
          </div>
          <ng-container *ngIf="showSupport">
            <a
              (click)="sidenav.mode === 'over' ? sidenav.close() : null"
              href="mailto:support@vetbooker.com"
              target="_blank"
              mat-list-item
              routerLinkActive="list-item-active"
            >
              <mat-icon
                [color]="isGroomRoom ? 'accent' : 'primary'"
                matListIcon
                style="margin-right: 20px"
              >
                support_agent
              </mat-icon>
              <h4
                style="margin: 0"
                [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
              >
                Technical support
              </h4>
            </a>
          </ng-container>
          <ng-container *ngIf="isGroomRoom">
            <a
              (click)="sidenav.mode === 'over' ? sidenav.close() : null"
              href="/privacy-policy"
              target="_blank"
              mat-list-item
              routerLinkActive="list-item-active"
            >
              <mat-icon
                [color]="isGroomRoom ? 'accent' : 'primary'"
                matListIcon
                style="margin-right: 20px"
              >
                info
              </mat-icon>
              <h4
                style="margin: 0"
                [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
              >
                Privacy Policy
              </h4>
            </a>
            <a
              (click)="sidenav.mode === 'over' ? sidenav.close() : null"
              href="/cookie-policy"
              target="_blank"
              mat-list-item
              routerLinkActive="list-item-active"
            >
              <mat-icon
                [color]="isGroomRoom ? 'accent' : 'primary'"
                matListIcon
                style="margin-right: 20px"
              >
                info
              </mat-icon>
              <h4
                style="margin: 0"
                [ngStyle]="{ color: isGroomRoom ? '#ffffff' : null }"
              >
                Cookie Policy
              </h4>
            </a>
          </ng-container>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content>
        <div fxLayout="column" fxFlexFill>
          <div
            *ngIf="isLoggedIn"
            class="toolbar"
            [ngClass]="{
              sticky: !hideNavigation && (termsAgreed$ | async),
              'background-color': !whiteBackground
            }"
          >
            <div fxLayout="row" fxLayoutAlign="center center">
              <button
                (click)="sidenav.toggle()"
                *ngIf="screenWidth <= 1260"
                mat-icon-button
              >
                <mat-icon>menu</mat-icon>
              </button>
              <ng-container *ngIf="screenWidth >= 900">
                <app-breadcrumbs></app-breadcrumbs>
              </ng-container>
              <img [src]="menuLogo" height="48px" />
              <div fxLayout="row" fxFlex fxLayoutAlign="end center">
                <button (click)="logout()" mat-button>
                  <ng-container *ngIf="whiteToolbar; else colorToolbarBlock">
                    <mat-icon [color]="isGroomRoom ? 'accent' : 'primary'"
                      >exit_to_app</mat-icon
                    >
                  </ng-container>
                  <ng-template #colorToolbarBlock>
                    <mat-icon style="color: white">exit_to_app</mat-icon>
                  </ng-template>
                </button>
              </div>
            </div>
          </div>
          <div
            [ngClass]="{ 'main-padding': !hideNavigation && isLoggedIn }"
            style="height: 100%"
          >
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <ng-template #elseBlock>
      <div fxFlexFill fxLayout="column" fxLayoutAlign="center center">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
        ></mat-progress-spinner>
        <p class="mat-body-2">Getting data from server</p>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
<ng-template #errorBlock>
  <app-error fxFlexFill></app-error>
</ng-template>

<ng-container *ngIf="!isLoggedIn && isGroomRoom">
  <div class="footer">
    <div class="footer-link">
      <a target="_blank" href="/privacy-policy">Privacy Policy</a>
    </div>
    <div class="footer-link">
      <a target="_blank" href="/cookie-policy">Cookie Policy</a>
    </div>
  </div>
</ng-container>
